import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
// this is the web typography implementation with inline in context
import React from 'react';
import classNames from 'classnames';
import { TypeImpl } from './TypeImpl';
import styles from './NativeType.module.less';
export var NativeType = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TypeImpl, _extends({
    ref: ref,
    className: classNames(className, // This is for consistent text rendering with react-native
    styles['pre-wrap'])
  }, props));
});
NativeType.displayName = 'NativeType';